import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ChartWidget as mainModule } from './main';
import { init as mainTheme } from './themes/main';

declare var require: any;
require('../sass-main/pdc-widget-chart.sass');

export class ChartWidget extends WidgetBase {
    public static _name: string = 'Chart';
    public static group = 'Charting';
    public static moduleName: string = 'pdc-widget-chart';
    public static icon: string = 'tasks';
    public static namespace: string = 'business-intelligence';
    public static themeModule = mainTheme;

    public static load() {
        let def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                let module: typeof mainModule = require('./main');
                def.resolve(module);
            },
            'pdc-widget-chart'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob = {}
    ) {
        values['themeNodeIdToExpand'] = 'widget-chart'; //VR: WI80078
        //values['themeNodeIdToExpand'] = 'widget-chart-Axis';  //LL: 07.11.19: try to expand to Axis (1st level under 'widget-chart')
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ChartWidget);
